import React, { Component } from 'react';
import { withContext } from '../utils/StateProvider';
import ActionButton from './action_button';

class explorationActionPanel extends Component {

  actionClick = (button) => {
    const { characterSheet, openCharacterSheet, closeCharacterSheet } = this.props.context;
    if (button === 'CHARACTER') {
      if (characterSheet === null) openCharacterSheet(0); else closeCharacterSheet();
      return;
    }
    if (characterSheet !== null) closeCharacterSheet();
    if (button === 'SHOOT (X)') {
      this.props.context.shoot();
    } else if (button === 'BASH (B)') {
      this.props.context.bashDoor();
    } else if (button === 'MAP') {
      this.props.context.toggleMap();
    } else if (button === 'USE (F)') {
      this.props.context.interact();
    } else if (button === 'SPELL (C)') {
      this.props.context.beginCast();
    } else if (button === 'WAIT') {
      this.props.context.wait();
    } else if (button === 'SLEEP') {
      this.props.context.rest();
    } else {
      this.props.context.update({
        eventLog:[...this.props.context.eventLog, {type:'dev', message:button + ' Clicked'}]
      })
    }
  }

  render() {
    return (
      <div id="actions">
        <ActionButton classes={['exploration','action']} alt="SHOOT (X)" icon="shoot" actionClick={this.actionClick} />
        <ActionButton classes={['exploration','action']} alt="SPELL (C)" icon="spell" actionClick={this.actionClick} />
        <ActionButton classes={['exploration','action']} alt="SLEEP" icon="sleep" actionClick={this.actionClick} />
        <ActionButton classes={['exploration','action']} alt="BASH (B)" icon="bash" actionClick={this.actionClick} />
        <ActionButton classes={['exploration','action']} alt="USE (F)" icon="dismiss" actionClick={this.actionClick} />
        <ActionButton classes={['exploration','action']} alt="QUEST LOG" icon="quest_log" actionClick={this.actionClick} />
        <ActionButton classes={['exploration','action']} alt="MAP" icon="map" actionClick={this.actionClick} />
        <ActionButton classes={['exploration','action']} alt="WAIT" icon="wait" actionClick={this.actionClick} />
        <ActionButton classes={['exploration','action']} alt="CHARACTER" icon="character" actionClick={this.actionClick} />
      </div>
    );
  }
}

export default withContext(explorationActionPanel);